module.exports = __webpack_public_path__ + "img/list-add.6b3551de.svg";